import R from 'ramda';

export const updateQueryStringWithoutReload = ({ shade }) => {
  const { protocol, host, pathname } = R.propOr({}, 'location', window);

  if (protocol && host && pathname) {
    const newurl = `${protocol}//${host}${pathname}?shade=${encodeURIComponent(
      shade
    )}`;

    window.history.pushState({ path: newurl }, '', newurl);
  }
};
